import styled, { css } from 'styled-components'

const commonWrap = css`
  display: grid;
  grid-template-columns: repeat(48, minmax(0, 1fr));
`

const spacedVertical = css`
  grid-row-gap: 1rem;
`

const spacedHorizontal = css`
  grid-column-gap: 1rem;
`

const fullCentered = css`
  grid-column: 1/-1;
`

const extraLargeCentered = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 4/-4;
  }
`

const largeCentered = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 8/-8;
  }
`

const baseCentered = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 12/-12;
  }
  @media (min-width: 1024px) {
    grid-column: 12/-12;
  }
`

const mediumCentered = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 16/-16;
  }
  @media (min-width: 1024px) {
    grid-column: 16/-16;
  }
`

const smallCentered = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 20/-20;
  }
  @media (min-width: 1024px) {
    grid-column: 20/-20;
  }
`

const sideLeft = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 12/-30;
  }
`

const sideRight = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 21/-12;
  }
`

const largeSideLeft = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 8/-30;
  }
`

const remainingSideRight = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 30/-8;
  }
`

const largeSideRight = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 21/-8;
  }
`

const largeSideOnLeft = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 8/-21;
  }
`

const smallSideOnRight = css`
  grid-column: 3/-3;
  @media (min-width: 768px) {
    grid-column: 21/-8;
  }
`

const Wrap = styled.div`
  ${commonWrap}
`

const Centered = styled.div`
  ${baseCentered}
`

const LargeCentered = styled.div`
  ${largeCentered}
`

const FullCentered = styled.div`
  ${fullCentered}
`

const Content = styled.div`
  ${commonWrap}
`

const ColLeft = styled.div`
  ${sideLeft}
`

const ColRight = styled.div`
  ${sideRight}
`

const LargeColLeft = styled.div`
  ${largeSideLeft}
`

const LargeColRight = styled.div`
  ${largeSideRight}
`

const LargeColOnLeft = styled.div`
  ${largeSideOnLeft}
`

const SmallColOnRight = styled.div`
  ${smallSideOnRight}
`

const RemainingSideRight = styled.div`
  ${remainingSideRight}
`

const WpContent = styled.div`
  .wp-blocks {
    ${commonWrap}
  }
  .wp-block {
    margin-bottom: 1rem;
  }
  .block--paragraph {
    ${sideRight}
  }
  .block--heading {
    ${sideRight}
    text-align: left;
    h2 {
      margin-top: 2rem;
      font-size: 4rem;
      line-height: 0.9;
      margin-bottom: 2rem;
    }
  }
  .block--image {
    margin-bottom: 2rem;
    &.image-size-sm {
      ${sideRight}
    }
    &.image-size-md {
      ${sideRight}
    }
    &.image-size-base {
      ${sideRight}
    }
    &.image-size-lg {
      ${largeCentered}
    }
    &.image-size-xl {
      ${extraLargeCentered}
    }
    &.image-size-xxl {
      ${extraLargeCentered}
    }
    figure {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    figcaption {
      font-family: 'Futura', sans-serif;
      line-height: 1.1;
      background-color: #1f4224;
      color: #e9d2a9;
      padding: 0.5rem;
    }
  }
  .block--html {
    ${baseCentered}
    margin-bottom: 2rem;
  }
  .block--embed {
    ${baseCentered}
    margin-bottom: 2rem;
  }
`

export {
  Wrap,
  Centered,
  LargeCentered,
  FullCentered,
  Content,
  WpContent,
  ColLeft,
  ColRight,
  LargeColLeft,
  LargeColRight,
  LargeColOnLeft,
  SmallColOnRight,
  RemainingSideRight,
  spacedVertical,
  spacedHorizontal,
}
